import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/projects',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/list/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/project/:id/:section?',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/edit/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/project/create',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/create/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
